import NullableFloat from '@/utils/customTypes/nullableFloat'
import { MapToContext } from '@utils/objectWithDefault'
import { PricingApiMessage, WroBoxPrices } from './shippingLabelPricing'

export class ShippingLabelPricingByShipOption {
  constructor (shippingLabelPricingData) {
    const defaultShippingLabelPricingData = {
      currencyCode: { val: '', type: String },
      totalPrice: { val: 0, type: NullableFloat },
      totalWeight: { val: 0, type: NullableFloat },
      shipOptionId: { val: 0, type: Number },
      zone: { val: 0, type: Number },
      message: { val: null, type: PricingApiMessage },
      wroBoxPrices: { val: [], type: Array, subType: WroBoxPrices },
      totalBoxes: { val: 0, type: Number }
    }
    MapToContext(
      this,
      defaultShippingLabelPricingData,
      shippingLabelPricingData
    )
  }
}
